import { useState } from 'react';
import styled from 'styled-components';
import Box from '../Box';
import Text from '../Text';

const CheckboxWrapper = styled(Box)`
  padding: 5px;
  &:hover {
    background: ${({ noHoverBG, hover, theme }) =>
      hover && !noHoverBG ? theme.colors.foreground : theme.colors.transparent};
  }
`;

const RSPCheckbox = styled.input.attrs({ type: 'checkbox' })``;

const CheckboxLabelWrapper = styled.label`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  ${({ disabled }) => disabled && 'cursor: auto; pointer-events: none;'};
`;

const CheckboxContent = styled(Box).attrs({
  justify: 'center',
  paddingLeft: '5px',
})``;

const CheckboxLabelAndIcon = styled(Box).attrs({
  horizontal: true,
})`
  gap: 4px;
`;

const CheckBoxLabel = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
  textAlign: 'left',
  fontWeight: 'regular',
})`
  display: ${({ noText }) => (noText ? 'none' : 'flex')};
  ${({ disabled }) => disabled && 'opacity: 0.3; '};
`;

const CheckboxDescription = styled(Text).attrs(({ ellipsis }) => ({
  color: 'secondaryText',
  textAlign: 'left',
  size: 'xsmall',
  ellipsis,
  fontWeight: 'regular',
}))`
  display: ${({ noText }) => (noText ? 'none' : 'flex')};
`;

const Checkbox = ({
  isChecked,
  description,
  disabled,
  label,
  onChange,
  onHover,
  noText,
  noHoverBG,
  className = '',
  checkboxID,
  labelIcon,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseHover = () => {
    if (onHover) {
      onHover();
    }

    setIsHovered(true);
  };

  return (
    <CheckboxWrapper
      className={className}
      hover={isHovered}
      onMouseEnter={handleMouseHover}
      onMouseLeave={() => setIsHovered(false)}
      noHoverBG={noHoverBG}
    >
      <CheckboxLabelWrapper disabled={disabled}>
        <RSPCheckbox
          checked={isChecked}
          disabled={disabled}
          onChange={onChange}
          id={checkboxID}
        />
        <CheckboxContent>
          <CheckboxLabelAndIcon>
            {labelIcon ? labelIcon : null}
            <CheckBoxLabel disabled={disabled} noText={noText}>
              {label}
            </CheckBoxLabel>
          </CheckboxLabelAndIcon>
          <CheckboxDescription noText={noText}>
            {description}
          </CheckboxDescription>
        </CheckboxContent>
      </CheckboxLabelWrapper>
    </CheckboxWrapper>
  );
};

export default Checkbox;
